<template>
  <!-- 会员地域分析 -->
  <div class="padding">
    <!-- 查询条件 -->
    <div class="zoneWrapper">
      <el-form label-width="100px">
        <el-form-item>
          付款时间：
          <el-radio
            v-model="queryForm.evaluateTime"
            @change="timeChange"
            v-for="item in options.evaluateTimeOpt"
            :key="item.value"
            :label="item.value"
            >{{ item.label }}</el-radio
          >
          <div class="my_select_time">
            <el-date-picker
              @change="startDateChange"
              prefix-icon="no_icon"
              v-model="form.startDate"
              type="datetime"
              :picker-options="pickerOptionsStart"
              :placeholder="'选择日期时间'"
              size="small"
              :disabled="queryForm.evaluateTime != 0 || !queryForm.evaluateTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 120px; font-size: 12px"
              class="time1"
              :clearable="false"
            ></el-date-picker>
            <div
              class="time_to_text"
              :class="{
                to_text_disabled:
                  queryForm.evaluateTime != 0 || !queryForm.evaluateTime,
              }"
            >
              至
            </div>
            <el-date-picker
              @change="endDateChange"
              prefix-icon="no_icon"
              v-model="form.endDate"
              type="datetime"
              :placeholder="'选择日期时间'"
              :picker-options="pickerOptionsEnd"
              size="small"
              :disabled="queryForm.evaluateTime != 0 || !queryForm.evaluateTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 145px; font-size: 12px"
              class="time2"
              :clearable="true"
            ></el-date-picker>
            <i
              class="el-icon-circle-close date_icon1"
              @click="clearTimeSendTime()"
            ></i>
            <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
          </div>
          <el-button
            type="primary"
            style="margin-left: 8px"
            class="b1"
            v-zoom="{ from: pageName, name: '查询' }"
            @click="info()"
            ><span style="marginleft: 4px"
              ><i
                class="el-icon-search"
                style="
                  display: inline-block;
                  width: 14px;
                  height: 12px;
                  margin-right: 4px;
                "
              ></i
              >查询</span
            ></el-button
          >
          <el-button style="margin-left: 20px" class="b2" @click="queryOne()"
            ><span style="marginleft: 4px">重置</span></el-button
          >
        </el-form-item>
      </el-form>
      <el-button class="exportData" @click="exportData">导出数据</el-button>
    </div>
    <!-- 提示栏 -->
    <div class="background">
      <span class="title"></span>&nbsp;
      <span class="tips">数据图表</span>
    </div>
    <!-- 会员地域分析 -->
    <div v-loading="loading">
      <div
        id="line-chart"
        class="chart-content"
        :style="{ width: '100%', height: '500px' }"
      ></div>
      <div class="background">
        <span class="title"></span>&nbsp;
        <span class="tips">数据报表</span>
      </div>
      <!-- 表格部分 -->
      <div class="table-box">
        <el-table
          id="setting-last-row"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="light"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; border: 1px solid #eee"
        >
          <template slot="empty">
            <div>
              <img src="@/assets/images/default/暂无任何数据.png" />
              <span style="margin-left: -140px">暂无任何数据</span>
            </div>
          </template>
          <el-table-column prop="areaName" label="会员等级"></el-table-column>
          <el-table-column
            prop="buyerCount"
            label="会员数"
          ></el-table-column>
          <el-table-column
            prop="tradeCount"
            label="订单数"
          ></el-table-column>
          <el-table-column prop="payment" label="成交金额（元）">
            <template slot-scope="scope">
              <span>{{ scope.row.payment.toFixed(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="buyerAvgCost" label="客单价（元）">
            <template slot-scope="scope">
              <span>{{ scope.row.buyerAvgCost.toFixed(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="会员数占比">
            <template slot-scope="scope">
              <el-progress :percentage="scope.row.memberCountRate"></el-progress>
            </template>
          </el-table-column>
          <el-table-column label="订单数占比">
            <template slot-scope="scope">
              <el-progress :percentage="scope.row.buyTotalRate"></el-progress>
            </template>
          </el-table-column>
          <el-table-column label="成交金额占比">
            <template slot-scope="scope">
              <el-progress :percentage="scope.row.buyTotalMoneyRate"></el-progress>
            </template>
          </el-table-column>
          <!-- <template>
            <div slot="append">
              <div class="summaryWrap">
                <div v-for="(item, index) in summaryData" :key="index">
                  <el-row type="flex">
                    <el-col
                      ><div class="grid-content">
                        {{ item.areaName }}
                      </div></el-col
                    >
                    <el-col
                      ><div class="grid-content">
                        {{ item.buyerCount }}
                      </div></el-col
                    >
                    <el-col
                      ><div class="grid-content">
                        {{ item.tradeCount }}
                      </div></el-col
                    >
                    <el-col
                      ><div class="grid-content">
                        {{ item.payment }}
                      </div></el-col
                    >
                    <el-col
                      ><div class="grid-content">
                        {{ item.buyerAvgCost }}
                      </div></el-col
                    >
                  </el-row>
                </div>
              </div>
            </div>
          </template> -->
        </el-table>
      </div>
    </div>
     <!-- 生成报表 -->
     <generate :control = 'control'
               v-if="control"
                @transData="(val) => (control = val)"
                @transData1 = 'getphone1'
                ></generate>
  </div>
</template>

<script>
import { close } from "fs";
import { mapState, mapMutations } from "vuex";
import { areaBuyerCount, exportData,exportDataOne } from "@/api/analysis/monthly-report";
import generate from '../../components/generate_report.vue'
require("echarts/map/js/china.js");
const geoCoordMap = [];
const data = [];
export default {
  name: "member-area",
  data() {
    return {
      control:false,
      pageName: "售后中心-地域分析",
      //时间限制
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.form.startDate) {
            return time.getTime() < new Date(this.form.startDate).getTime();
          } else {
          }
        },
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.form.endDate) {
            return time.getTime() > new Date(this.form.endDate).getTime();
          } else {
          }
        },
      },
      loading: true,
      //查询条件
      options: {
        evaluateTimeOpt: [
          {
            value: "",
            label: "全部",
          },
          {
            value: "7",
            label: "近七天",
          },
          {
            value: "30",
            label: "近一个月",
          },
          {
            value: "0",
            label: "自定义",
          },
        ],
      },
      mytime: [],
      timedate: [],
      form: {
        startDate: "",
        endDate: "",
      },
      queryForm: {
        evaluateTime: "30",
      },
      tableData: [],
      summaryData: [],
    };
  },
  components: {
    generate
  },
  computed: {
    ...mapState({
      changeColor: "globalBG",
      //   把city映射给currentCIty
    }),
  },
  mounted() {
    const date = [
      this.getDay(-1, "-") + " 00:00:00",
      this.getDay(-1, "-") + " 00:00:00",
    ];
    this.mytime = date;
    // this.form.startTime = this.mytime[0];
    // this.form.endTime = this.mytime[1];
    this.timeChange("30");
    this.info();
  },
  methods: {
    startDateChange(time) {
      this.form.startDate = time
    },

    endDateChange(time) {
      this.form.endDate = time
    },

    // 导出数据
    async exportData() {
      this.control = true
    },
    getphone1(val){
      let paramStr = "";
      this.form.yearRange = 0
      this.form.exportRemark  = val
      for (var key in this.form) {
        let temp = "&" + key + "=" + this.form[key];
        paramStr += temp;
      }
      paramStr = paramStr.substr(1);
      exportDataOne(paramStr).then((res)=>{
         if(res.code==1){
          this.control = true
         }else{
          this.$message.error(res.message);
         }
      })
    },
    clearTimeSendTime() {
      this.form.endDate = "";
      this.form.startDate = "";
    },
    timeChange(type) {
      let self = this;
      const date = [self.getDay(-7, "-"), self.getDay(0, "-")];
      this.mytime = date;
      let nowTime = new Date()
      if (type == 7) {
        this.form.startDate = this.mytime[0] + " " + nowTime.toLocaleTimeString();
        this.form.endDate = this.mytime[1] + " " + nowTime.toLocaleTimeString();
      } else if (type == 30) {
        this.mytime[0] = self.getDay(-30, "-");
        this.mytime[1] = self.getDay(0, "-");
        this.form.startDate = this.mytime[0] + " " + nowTime.toLocaleTimeString();
        this.form.endDate = this.mytime[1] + " " + nowTime.toLocaleTimeString();
      } else {
        this.form.startDate = "";
        this.form.endDate = "";
      }
    },
    //重置
    queryOne() {
      this.queryForm.evaluateTime = "";
      this.form.startDate = "";
      this.form.endDate = "";
      this.info();
    },
    info() {
      this.loading = true;
      areaBuyerCount(this.form).then((res) => {
        if (res.data !== "") {
          this.tableData = res.data.map((item) => {
            return {
              areaName: item.locationState,
              buyerCount: Number(item.memberCount),
              tradeCount: Number(item.buyTotalCount),
              payment: Number(item.buyTotalMoney),
              buyerAvgCost: Number(item.unitPrice),
              memberCountRate: Number(item.memberCountRate),
              buyTotalRate: Number(item.buyTotalRate),
              buyTotalMoneyRate: Number(item.buyTotalMoneyRate)
            };
          });
        } else {
          this.tableData = [];
        }
        var timedate = [
          { name: "北京", value: 0, itemStyle: { normal: { color: "red" } } },
          { name: "天津", value: 0 },
          { name: "上海", value: 0 },
          { name: "重庆", value: 0 },
          { name: "河北", value: 0 },
          { name: "河南", value: 0 },
          { name: "云南", value: 0 },
          { name: "辽宁", value: 0 },
          { name: "黑龙江", value: 0 },
          { name: "湖南", value: 0 },
          { name: "安徽", value: 0 },
          { name: "山东", value: 0 },
          { name: "新疆", value: 0 },
          { name: "江苏", value: 0 },
          { name: "浙江", value: 0 },
          { name: "江西", value: 0 },
          { name: "湖北", value: 0 },
          { name: "广西", value: 0 },
          { name: "甘肃", value: 0 },
          { name: "山西", value: 0 },
          { name: "内蒙古", value: 0 },
          { name: "陕西", value: 0 },
          { name: "吉林", value: 0 },
          { name: "福建", value: 0 },
          { name: "贵州", value: 0 },
          { name: "广东", value: 0 },
          { name: "青海", value: 0 },
          { name: "西藏", value: 0 },
          { name: "四川", value: 0 },
          { name: "宁夏", value: 0 },
          { name: "海南", value: 0 },
          { name: "台湾", value: 0 },
          { name: "香港", value: 0 },
          { name: "澳门", value: 0 },
        ];
        function randomData() {
          return Math.round(Math.random() * 500);
        }
        for (let i = 0; i < res.data.length; i++) {
          checkFn(i, timedate);
        }
        function checkFn(num, timedate) {
          timedate.forEach(function (item) {
            if (res.data[num].locationState == "海南省") {
              item.value = parseInt(res.data[num].memberCount);
            }
            if (item.name == res.data[num].locationState) {
              item.value = parseInt(res.data[num].memberCount);
            }
          });
        }
        this.timedate = timedate;
        this.drawLine();
      });
    },
    drawLine() {
      this.$nextTick(function () {
        this.loading = false;
        let chart = this.$echarts.init(document.getElementById("line-chart"));
        window.onresize = chart.resize;
        chart.setOption({
          tooltip: { trigger: "item" },
          visualMap: {
            //左边小工具
            min: 0,
            max: 5000,
            left: "left",
            top: "bottom",
            text: ["高", "低"],
            seriesIndex: [1],
            inRange: {
              color: ["#AAD5FF", "#5882FB"],
            },
            calculable: true,
          },

          roamController: {
            show: true,
            x: "left",
            padding: [50, 0],
            mapTypeControl: {
              china: true,
            },
          },
          // 去除数据视图
          // toolbox: {
          //   show: true,
          //   x: "top",
          //   y: "top",
          //   left: "12",
          //   feature: {
          //     mark: { show: false },
          //     dataView: { tittle: "数据视图", show: true, readOnly: false },
          //     restore: { show: true },
          //     saveAsImage: { show: true },
          //   },
          // },
          geo: {
            // 这个是重点配置区
            map: "china", //表示中国地图
            roam: true,
            label: {
              normal: {
                // show: true, // 是否显示对应地名
                textStyle: {
                  color: "rgba(0,0,0,.8)",
                },
              },
            },
            itemStyle: {
              normal: {
                borderColor: "rgba(0, 0, 0, 0.2)",
              },
              emphasis: {
                areaColor: null,
                shadowOffsetX: 0,
                shadowOffsetY: 0,
                shadowBlur: 20,
                borderWidth: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
                // 径向渐变，前三个参数分别是圆心 x, y 和半径，取值同线性渐变
                color: "#FFF9AA",
              },
            },
          },
          series: [
            {
              type: "scatter",
              coordinateSystem: "geo", //对应上方配置
            },
            {
              name: "客户区域人数", //浮动框的标题
              type: "map",
              geoIndex: 0,
              data: this.timedate,
              itemStyle: {
                normal: { label: { show: true } },
              },
            },
          ],
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-progress-bar {
  padding-right: 70px;
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  margin-right: -76px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

/deep/.el-progress-bar__inner {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background-color: #7e86ec;
  text-align: right;
  border-radius: 100px;
  line-height: 1;
  white-space: nowrap;
  -webkit-transition: width 0.6s ease;
  transition: width 0.6s ease;
}

.zoneWrapper {
  position: relative;
  margin: 5px 0 20px 35px;

  .exportData {
    position: absolute;
    top: 0;
    right: 0;
  }
}

/deep/.el-radio__label {
  padding-left: 8px;
}
/deep/ .padding .el-form-item__content {
  margin-left: -30px !important;
}
@mixin translateX($number) {
  -webkit-transform: translateX($number);
  -moz-transform: translateX($number);
  -ms-transform: translateX($number);
  -o-transform: translateX($number);
  transform: translateX($number);
}
@mixin translateY($number) {
  -webkit-transform: translateY($number);
  -moz-transform: translateY($number);
  -ms-transform: translateY($number);
  -o-transform: translateY($number);
  transform: translateY($number);
}
@mixin translate($number, $number2) {
  -webkit-transform: translateX($number) translateY($number2);
  -moz-transform: translateX($number) translateY($number2);
  -ms-transform: translateX($number) translateY($number2);
  -o-transform: translateX($number) translateY($number2);
  transform: translateX($number) translateY($number2);
}
.section-right-content-box {
  min-width: 1366px;
  background-color: #fff;
  /*box-shadow: 0px 8px 20px rgba(139, 156, 188, 0.16);*/
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  padding: 24px 12px 24px 30px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  box-shadow: 0px 4px 12px rgba(221, 221, 221, 0.3);
  border: 1px solid rgba(230, 230, 230, 1);
}
.section-right-content-box2 {
  min-width: 1046px;
  background-color: #fff;
  box-shadow: 0px 4px 12px rgba(221, 221, 221, 0.3);
  border: 1px solid rgba(230, 230, 230, 1);
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  overflow: hidden;
  margin: 10px 20px 20px 20px;
  .padding {
    padding: 40px 20px 20px;
  }
  .b1 {
    width: 98px;
    height: 32px;
    color: #fe4d45;
    font-size: 14px;
    border-radius: 3px;
    border: 1px solid #fe4d45;
    background-color: #fff;
    &:hover {
      color: #fff;
      border: 1px solid #fff;
      background-color: #fe4d45;
    }
  }
  .b2 {
    width: 98px;
    height: 32px;
    font-size: 14px;
    border-radius: 3px;
    color: #666666;
    border: 1px solid #dddddd;
    background-color: #fff;
    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
}
.background {
  height: 32px;
  background: rgba(250, 250, 250, 1);
  opacity: 1;
  line-height: 32px;
  padding-left: 12px;
  margin-top: 20px;
  .title {
    display: inline-block;
    width: 2px;
    height: 14px;
    background: rgba(254, 77, 69, 1);
    opacity: 1;
    border-radius: 3px;
    vertical-align: middle;
  }
  .tips {
    width: 56px;
    height: 20px;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: rgba(51, 51, 51, 1);
    opacity: 1;
    vertical-align: middle;
  }
}
.form-item {
  display: flex;
  align-items: center;
}
.condition-label {
  font-size: 14px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  line-height: 32px;
  color: rgba(102, 102, 102, 1);
  text-align: right;
  width: 76px;
  padding-right: 12px;
}
.table-box {
  margin-top: 14px;
}
.button-box {
  margin-top: 90px;
  .float-right-button {
    float: right;
    .button {
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      display: inline-block;
      vertical-align: middle;
      padding: 0px 16px;
      font-size: 14px;
      height: 32px;
      line-height: 30px;
      -webkit-border-radius: 2px;
      -moz-border-radius: 2px;
      border-radius: 2px;
      margin-right: 15px;
      cursor: pointer;
      .button-icon {
        display: inline-block;
        vertical-align: middle;
        margin-right: 8px;
      }
      .button-title {
        display: inline-block;
        vertical-align: middle;
      }
    }

    .button:last-child {
      margin-right: 0;
    }
  }
}
/* 导出数据模态框 */
.export-dialog-wrapper {
  .title {
    margin-bottom: 10px;
    margin-left: 40px;
    .highlight-text {
      color: #ff7600;
      display: inline-block;
      vertical-align: middle;
      margin-left: 10px;
    }
  }
  .checked-box {
    margin-left: 40px;
    .checked-item {
      width: 110px;
      margin-bottom: 8px;
    }
  }
}
.dialog-footer {
  text-align: right;
  .el-button {
    height: 32px;
  }
}
.summaryWrap {
  width: 100%;
  height: auto;
  color: rgba(32, 98, 231, 1);
}
.grid-content {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  line-height: 23px;
  padding: 10px 0px;
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 0px;
  color: rgba(32, 98, 231, 1);
}
</style>
